<template>
  <tab 
    ref="tab"
    :id="id" 
    :label="label"
    :color-index="colorIndex"
    @close="onClosed"
    @resize="onResized"
  />
</template>

<script>
import Tab from '../../../../../svgchartlib-v3/lib/Components/Z_Projects/COMMON/ModalTaps'

export default {
  name: 'j-modal-slide-tab',
  components: {
    Tab
  },
  props: {
    id: String,
    label: String,
    colorIndex: { type: Number, default: () => 0 },
    value: null
  },
  data: () => ({
    // colorIndex: 0,
  }),
  mounted() {
    this.$nextTick(() => this.draw())
  },
  watch: {
    colorIndex: {
      immediate: false,
      handler() {
        this.draw()
      }
    }
  },
  methods: {
    onClosed() {
      this.$emit('close')
    },
    onResized(d) {
      this.$emit('resize', d)
    },
    draw() {
      // this.$refs.tab.colorIndex = this.colorIndex
      // this.$refs.tab.draw()

      this.$refs.tab?.draw?.()
    }
  }
}
</script>
